import { useFormikContext } from 'formik';

// import { useClinicalNoteContext } from 'lib/context/ClinicalNoteContext/ClinicalNoteContext';
// import { useMacrosContext } from 'lib/context/MacrosContext/MacrosContext';
// import { cn, iaRa } from 'lib/helpers/utility';

// import { getTypeOfNotes } from 'components/practice/charts/ClinicalNote/MyScribeAI/lib/helpers';
// import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';

// import Typography from 'components/shared/Typography/Typography';

// import FormSelect from '../FormSelect/FormSelect';

// import FormsList from '../FormsList';

const AppointmentMacroForm = () => {
  const { values, errors, setFieldValue } = useFormikContext();
  // const { cnDisplaySettings, advancedHP, advancedSOAP, customFormTypes } = useClinicalNoteContext();

  // const { activeMacro } = useMacrosContext();

  // const selectHandler = (note, form, checked) => {
  //   const prev = values?.body?.forms;

  //   const newData = [...iaRa(prev?.[note])];

  //   if (checked) {
  //     newData.push(form);
  //   } else {
  //     const index = newData.findIndex((item) => item === form);
  //     if (index > -1) {
  //       newData.splice(index, 1);
  //     }
  //   }

  //   const newValue = { ...prev, [note]: newData };

  //   setFieldValue('body', { forms: newValue });
  // };

  // const typeOfNotes = getTypeOfNotes({
  //   cnDisplaySettings,
  //   advancedHP,
  //   advancedSOAP,
  //   customFormTypes
  // });

  // const forms = values?.body?.forms;

  // const hasForms = io(forms) && Object.values(forms).flat().length;

  return (
    <>
      <div className="flex gap-x-4">
        <Input
          id="appointment-macro-input-name"
          className="basis-full"
          label="Appointment macro name"
          data-qa="enter-appointment-template-label"
          placeholder="Enter appointment macro name"
          name="name"
          autoComplete="off"
          value={values?.name}
          onChange={(event) => setFieldValue('name', event.target.value)}
          required={true}
          error={errors?.name}
        />

        {/* <div className="basis-1/4">
            <FormSelect variant="popover" selectedItems={forms} selectHandler={selectHandler} />
          </div> */}
      </div>

      {/* {!activeMacro ? (
        <>
          <div className="my-6 h-px bg-neutral-100"></div>

          {hasForms ? (
            <FormsList selectedForms={forms} typeOfNotes={typeOfNotes} className="pb-[124px]" />
          ) : (
            <div>
              <div className="flex w-full flex-col items-center justify-center gap-y-1">
                <Icon icon="illustration-choose-enhance-note" className="mb-6" />
                <Typography variant="label" size="large" color="primary-900">
                  Select appointment forms that you want to create a macro!
                </Typography>
                <Typography color="neutral-600">
                  After selecting, the forms will be rendered here.
                </Typography>
              </div>
            </div>
          )}
        </>
      ) : null} */}
    </>
  );
};

export default AppointmentMacroForm;
